import { render, staticRenderFns } from "./editcustomergroup.vue?vue&type=template&id=e94a9f46&scoped=true&"
import script from "./editcustomergroup.vue?vue&type=script&lang=js&"
export * from "./editcustomergroup.vue?vue&type=script&lang=js&"
import style0 from "./editcustomergroup.vue?vue&type=style&index=0&id=e94a9f46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e94a9f46",
  null
  
)

export default component.exports